import React from 'react'

function AgeVarify() {

    return (
        <div style={{
            height: '82%'
        }}>
            <label style={{fontSize:'20px'}}>
                  I confirm that I am 18 years of age or older.
                </label>
        </div>
    )
}

export default AgeVarify
